import React from 'react';
import { Button } from './Button';
interface PlanCardProps {
  badge: string;
  title: string;
  subtitle?: string;
  items: string[];
  originalPrice?: string;
  price: string;
  savings?: string;
  buttonText: string;
  href: string;
  featured?: boolean;
  image?: string;
}
export function PlanCard({
  badge,
  title,
  subtitle,
  items,
  originalPrice,
  price,
  savings,
  buttonText,
  href,
  featured = false,
  image
}: PlanCardProps) {
  if (featured) {
    return <div className="bg-gradient-to-b from-brand-pink to-[#c01471] rounded-3xl p-6 sm:p-7 flex flex-col text-left border-2 border-brand-pink relative shadow-2xl shadow-brand-pink/30 md:scale-105 md:-my-2" data-id="element-197">
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-yellow-400 text-brand-navy px-4 py-1 rounded-full text-xs font-black uppercase tracking-wide whitespace-nowrap shadow-lg" data-id="element-198">
          🔥 MÁS ELEGIDO
        </div>
        {image && <div className="mb-4 mt-2 flex justify-center" data-id="element-199">
            <img src={image} alt={title} className="h-44 w-auto object-contain drop-shadow-lg" data-id="element-200" />
          </div>}
        <div className="inline-block self-start bg-white/20 text-white px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider mb-4 mt-2" data-id="element-201">
          {badge}
        </div>
        {title && <h3 className="text-white font-black text-xl sm:text-2xl mb-3 leading-tight" data-id="element-202">
            {title}
          </h3>}
        {subtitle && <p className="text-white/90 text-sm mb-6 leading-relaxed" data-id="element-203">
            {subtitle}
          </p>}
        <ul className="space-y-2 mb-6 text-sm" data-id="element-204">
          {items.map((item, i) => <li key={i} className="flex items-start text-white font-medium" data-id="element-205">
              <span className="mr-2 text-yellow-300 text-base font-bold" data-id="element-206">
                ✓
              </span>
              {item}
            </li>)}
        </ul>
        <div className="mt-auto" data-id="element-207">
          {originalPrice && <p className="text-white/70 line-through text-sm mb-1" data-id="element-208">
              {originalPrice}
            </p>}
          <div className="text-3xl sm:text-4xl font-black text-white mb-1" data-id="element-209">
            {price}
          </div>
          {savings && <p className="text-[11px] text-yellow-200 font-bold mb-5" data-id="element-210">
              {savings}
            </p>}
          <a href={href} className="inline-flex items-center justify-center w-full px-6 py-4 text-base sm:text-lg font-black text-brand-pink bg-white rounded-xl hover:bg-yellow-50 shadow-md hover:shadow-lg transition-all uppercase tracking-wide" data-id="element-211">
            {buttonText}
          </a>
          <p className="mt-3 text-[10px] font-[500] text-white/80 text-center" data-id="element-212">
            Pago único · Acceso de por vida
          </p>
        </div>
      </div>;
  }
  return <div className="bg-[#0f1b33] rounded-3xl p-6 sm:p-7 flex flex-col text-left border border-white/10" data-id="element-213">
      {image && <div className="mb-4 flex justify-center" data-id="element-214">
          <img src={image} alt={title} className="h-44 w-auto object-contain drop-shadow-lg" data-id="element-215" />
        </div>}
      <div className="inline-block self-start bg-white/10 text-gray-200 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider mb-4" data-id="element-216">
        {badge}
      </div>
      <h3 className="text-white font-bold text-lg sm:text-xl mb-3 leading-tight" data-id="element-217">
        {title}
      </h3>
      {subtitle && <p className="text-gray-400 text-sm mb-6 leading-relaxed" data-id="element-218">{subtitle}</p>}
      <ul className="space-y-2 mb-6 text-sm" data-id="element-219">
        {items.map((item, i) => <li key={i} className="flex items-start text-gray-200" data-id="element-220">
            <span className="mr-2 text-green-400 text-base" data-id="element-221">✓</span>
            {item}
          </li>)}
      </ul>
      <div className="mt-auto" data-id="element-222">
        <div className="text-3xl sm:text-4xl font-black text-white mb-1" data-id="element-223">
          {price}
        </div>
        <p className="text-[11px] text-gray-400 mb-5" data-id="element-224">
          Pago único · Acceso de por vida
        </p>
        <Button className="w-full" href={href} data-id="element-225">
          {buttonText}
        </Button>
      </div>
    </div>;
}